import React, { useCallback, useContext } from 'react';
import _ from 'underscore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ServerContextProvider } from '@bingads-webui-campaign-react/shared-app-capi';
import { ServerContext, useUpdateServerContext } from '@bingads-webui-campaign-react/server-context';
import {
  TermsAndConditions as TermsAndConditionsComponent,
  withClientCenterApiContext,
} from '@bingads-webui-campaign-react/business-and-payment-setup';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { isSignupRunningProxy } from '@bingads-webui-campaign-react/pmax-language-country';

const getTermsAndConditionsStyles = () => ({
  termsAndConditionsContainer: {
    '& .tc-validation-note': {
      color: '#A80000',
      fontSize: '12px',
    },
  },
});

const WrappedTermsAndConditions = withClientCenterApiContext(props => (<TermsAndConditionsComponent {...props} />));

export const TermsAndConditions = ({
  terms = {},
  countryCode,
  showValidationResult,
  updateBizInfoData,
}) => {
  const serverContext = useContext(ServerContext);
  const updateServerContextFn = useUpdateServerContext();
  const classes = useDefaultStyles(getTermsAndConditionsStyles);

  const isDebugging = isSignupRunningProxy();

  const onTermAndConditionChange = useCallback(({ accepted, communication }) => {
    updateBizInfoData({
      terms: {
        accepted,
        shouldDisableChecked: !!terms.shouldDisableChecked,
        communication: {
          // make sure non-nullable properties are always sent to the server
          AllowContact: false,
          ...(terms.communication || {}),
          ...communication,
        },
      },
    });
  }, [terms.communication, terms.shouldDisableChecked, updateBizInfoData]);

  if (isDebugging) {
    return null;
  }

  return (
    <ServerContextProvider serverContext={serverContext} updateServerContext={updateServerContextFn} >
      <div className={classNames('terms-and-conditions-container', classes.termsAndConditionsContainer)}>
        <WrappedTermsAndConditions
          country={countryCode}
          onChange={onTermAndConditionChange}
          showValidationResult={showValidationResult}
          isTAndCChecked={terms.accepted}
          isDisabled={terms.shouldDisableChecked}
          communication={terms.communication || {}}
        />
      </div>
    </ServerContextProvider>
  );
};

TermsAndConditions.propTypes = {
  terms: PropTypes.shape({
    accepted: PropTypes.bool,
    shouldDisableChecked: PropTypes.bool,
    communication: PropTypes.shape({
      AllowContact: PropTypes.bool,
      AllowContactByPhone: PropTypes.bool,
    }),
  }).isRequired,
  countryCode: PropTypes.string.isRequired,
  showValidationResult: PropTypes.bool,
  updateBizInfoData: PropTypes.func,
};

TermsAndConditions.defaultProps = {
  showValidationResult: false,
  updateBizInfoData: _.noop,
};
